// Non-React rotation state for the brains, mutated during drag and read in
// useFrame (avoids per-frame React re-renders). Index 0=side, 1=coronal, 2=top.
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

export const viewState = {
  sync: true,
  rot: [
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
  ],
};

export function setSync(v) {
  viewState.sync = v;
}

export function resetViews() {
  for (const r of viewState.rot) {
    r.x = 0;
    r.y = 0;
  }
}

// dx, dy are pointer pixel deltas. In sync mode the same delta is applied to
// every brain so they mirror each other; otherwise only the dragged brain moves.
export function dragView(index, dx, dy) {
  const s = 0.008;
  if (viewState.sync) {
    for (const r of viewState.rot) {
      r.y += dx * s;
      r.x = clamp(r.x + dy * s, -1.3, 1.3);
    }
  } else {
    const r = viewState.rot[index];
    r.y += dx * s;
    r.x = clamp(r.x + dy * s, -1.3, 1.3);
  }
}
